import React from "react";

const CommingSoon = () => {
  return (
    <>
      <div className="privacy-container coming-soon-container">
        <div className="container ">
          <div className="head">
            <h1>COMING SOON</h1>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommingSoon;
